/**
 * Uebersetzen ausserhalb eines Bauteils.
 *
 * `useI18n()` gibt es nur im Setup eines Bauteils. Speicher, Composables und
 * Hilfsdateien brauchen denselben Zugang, sonst bleiben genau die Saetze
 * deutsch, die im Fehlerfall erscheinen — und das sind die, bei denen jemand
 * am ehesten Hilfe braucht.
 *
 * Der Aufruf liest die Sprache bei jedem Mal neu. Wer eine Meldung in einer
 * Konstanten festhaelt, friert dagegen die Sprache des Ladezeitpunkts ein.
 *
 * Mit `anzahl` waehlt vue-i18n die Mehrzahl-Form eines Textes wie
 * „{n} Eintrag | {n} Einträge".
 */
import i18n from '@/locales'

export function uebersetze(schluessel: string, werte?: Record<string, unknown>, anzahl?: number): string {
  return anzahl === undefined
    ? i18n.global.t(schluessel, werte ?? {}) as string
    : i18n.global.t(schluessel, werte ?? {}, anzahl) as string
}
